module.exports = __webpack_public_path__ + "static/delete-tweet-dialog.e0493d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forms/tutorial/delete-tweet-dialog.png
// module id = 2539
// module chunks = 93772435260754